/***
 * @file:æç¤ºä¿¡æ¯æ¥å£
 * @author: linkun.he
 * @Date: 2019-09-20 09:29:28
 */
export interface DtNotificationDataOptions {
  dtKey?: string;
  dtPlacement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
  dtDuration?: number;
  dtStyle?: any;
  dtClass?: any;
}

export interface NzNotificationDataOptions<T = {}> {
  nzKey?: string;
  nzDuration?: number;
  nzStyle?: any;
  nzClass?: any;
  nzData?: T;
}

export const DT_DEFAULT_NOTIFICATION = {
  nzDuration: 1000,
};
